import { RouteConstant } from "@/util/constant/RouteConstant.ts";
import { RouteType } from "@/router/route/index.ts";
import DashboardView from "../../views/dashboard/DasboardView.tsx";
import ApplicationWorkspaceView from "../../views/dashboard/ApplicationWorkspaceView.tsx";
import EntityView from "../../views/dashboard/EntityView.tsx";
import AttributeView from "../../views/dashboard/AttributeView.tsx";
import CreateWorkspaceView from "@/views/dashboard/CreateWorkspaceView.tsx";
import BillingView from "@/views/dashboard/BillingView.tsx";
import Integration from "@/views/dashboard/Integration.tsx";
import Terms from "@/views/terms-conditions/index.tsx";

export const dashboardRoute: RouteType[] = [
  {
    path: RouteConstant.dashboard.dashboard.path,
    name: RouteConstant.dashboard.dashboard.name,
    component: DashboardView,
    metadata: { isAuthenticated: true, hasSidebar: true },
  },
  {
    path: RouteConstant.dashboard.integration.path,
    name: RouteConstant.dashboard.integration.name,
    component: Integration,
    metadata: { isAuthenticated: true, hasSidebar: true },
  },
  {
    path: RouteConstant.dashboard.createWorkspace.path,
    name: RouteConstant.dashboard.createWorkspace.name,
    component: CreateWorkspaceView,
    metadata: { isAuthenticated: true, hasSidebar: true },
  },

  {
    path: RouteConstant.dashboard.billing.path,
    name: RouteConstant.dashboard.billing.name,
    component: BillingView,
    metadata: { isAuthenticated: true },
  },

  {
    path: RouteConstant.dashboard.entity.path,
    name: RouteConstant.dashboard.entity.name,
    component: EntityView,
    metadata: { isAuthenticated: true, hasSidebar: true },
  },
  {
    path: RouteConstant.dashboard.attribute.path,
    name: RouteConstant.dashboard.attribute.name,
    component: AttributeView,
    metadata: { isAuthenticated: true, hasSidebar: true },
  },
  {
    path: RouteConstant.dashboard.applicationWorkspace.path,
    name: RouteConstant.dashboard.applicationWorkspace.name,
    component: ApplicationWorkspaceView,
    metadata: { isAuthenticated: true, hasSidebar: true },
  },
];
